import type { TrendItemContentTweetsItemReferencedTweetTweet } from './trendItemContentTweetsItemReferencedTweetTweet';
import type { TrendItemContentTweetsItemReferencedTweetType } from './trendItemContentTweetsItemReferencedTweetType';

/**
 * 참조된 트윗 정보 (답글, 인용, 리트윗인 경우)
 */
export type TrendItemContentTweetsItemReferencedTweet = {
  /** 참조된 트윗 ID */
  id?: string;
  /** 참조된 트윗 요약 정보 (순환 참조 방지) */
  tweet?: TrendItemContentTweetsItemReferencedTweetTweet;
  type?: TrendItemContentTweetsItemReferencedTweetType;
};
